(function () {
  if (window.__saveForLaterInitialized) return;
  window.__saveForLaterInitialized = true;

  const STORAGE_KEY = "saveForLater:v2";

  function readItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (i) {
        return i && i.id != null && i.name != null;
      });
    } catch {
      return [];
    }
  }

  function writeItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  window.SaveForLaterStore = {
    read: readItems,

    add(entry) {
      const id = String(entry.id);
      const item = {
        id,
        name: String(entry.name || ""),
        image: String(entry.image || ""),
        price: String(entry.price || ""),
        productUrl: String(entry.productUrl || ""),
      };
      const items = readItems().filter(function (i) {
        return String(i.id) !== id;
      });
      items.push(item);
      writeItems(items);
      renderAllSavedListViews();
    },

    removeById(id) {
      const s = String(id);
      writeItems(
        readItems().filter(function (i) {
          return String(i.id) !== s;
        }),
      );
      renderAllSavedListViews();
    },

    clearAll() {
      writeItems([]);
      renderAllSavedListViews();
    },
  };

  function cartAddJsUrl() {
    var base = String(routes.cart_add_url || "/cart/add");
    return base.indexOf(".js") !== -1 ? base : base.replace(/\/?$/, "") + ".js";
  }

  function cartJsUrl() {
    var base = String((routes && routes.cart_url) || "/cart");
    return base.indexOf(".js") !== -1 ? base : base.replace(/\/?$/, "") + ".js";
  }

  function fetchCartState() {
    return fetch(cartJsUrl(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }).then(function (response) {
      if (!response.ok) throw new Error("cart-fetch-failed");
      return response.json();
    });
  }

  function restoreToCart(id) {
    var variantId = Number(id);
    fetchCartState()
      .then(function (cartState) {
        var existsInCart =
          cartState &&
          Array.isArray(cartState.items) &&
          cartState.items.some(function (item) {
            return Number(item.variant_id) === variantId;
          });
        if (existsInCart) return null;
        return fetch(cartAddJsUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        }).then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              var msg =
                (body && (body.description || body.message)) ||
                (window.cartStrings && window.cartStrings.error);
              if (msg) window.alert(msg);
              return Promise.reject(new Error("cart-add-failed"));
            });
          }
          return response.json();
        });
      })
      .then(function (result) {
        if (result === null) {
          window.SaveForLaterStore.removeById(id);
          window.location.reload();
          return;
        }
        if (
          result &&
          (result.status === 422 ||
            result.errors ||
            (typeof result.status === "number" && result.status >= 400))
        ) {
          var msg =
            result.description ||
            result.message ||
            (window.cartStrings && window.cartStrings.error);
          if (msg) window.alert(msg);
          return;
        }
        window.SaveForLaterStore.removeById(id);
        window.location.reload();
      })
      .catch(function () {
        if (window.cartStrings && window.cartStrings.error) {
          window.alert(window.cartStrings.error);
        }
      });
  }

  function renderSavedListInto(list, options) {
    if (!list) return;
    var empty = options.empty;
    var toolbar = options.toolbar;
    var showToolbar = !!options.showToolbar;
    var container = options.container || null;
    var hideWhenEmpty = !!options.hideWhenEmpty;
    var items = readItems();
    var str = window.saveForLaterStrings || {};
    var removeLabel = str.removeOne || "Remove";
    var restoreLabel = str.restoreOne || "Restore";

    if (items.length === 0) {
      list.innerHTML = "";
      if (empty) empty.classList.remove("hidden");
      if (toolbar) toolbar.classList.add("hidden");
      if (container && hideWhenEmpty) container.classList.add("hidden");
      return;
    }
    if (empty) empty.classList.add("hidden");
    if (toolbar && showToolbar) toolbar.classList.remove("hidden");
    if (container && hideWhenEmpty) container.classList.remove("hidden");

    list.innerHTML = items
      .map(function (row) {
        var img = row.image
          ? '<img src="' +
            escapeAttr(row.image) +
            '" alt="" width="120" height="120" loading="lazy" class="save-for-later-page__img">'
          : '<div class="save-for-later-page__img save-for-later-page__img--empty"></div>';
        var title = row.productUrl
          ? '<a href="' +
            escapeAttr(row.productUrl) +
            '" class="save-for-later-page__name-link">' +
            escapeHtml(row.name) +
            "</a>"
          : escapeHtml(row.name);
        return (
          '<div class="save-for-later-page__row" data-id="' +
          escapeAttr(row.id) +
          '">' +
          '<div class="save-for-later-page__media">' +
          img +
          "</div>" +
          '<div class="save-for-later-page__info">' +
          "<p class=\"save-for-later-page__name\">" +
          title +
          "</p>" +
          '<p class="save-for-later-page__price">' +
          escapeHtml(row.price) +
          "</p>" +
          '<div class="save-for-later-page__actions">' +
          '<button type="button" class="save-for-later-page__restore" data-restore-id="' +
          escapeAttr(row.id) +
          '">' +
          escapeHtml(restoreLabel) +
          "</button>" +
          '<button type="button" class="save-for-later-page__remove" data-remove-id="' +
          escapeAttr(row.id) +
          '">' +
          escapeHtml(removeLabel) +
          "</button>" +
          "</div>" +
          "</div>" +
          "</div>"
        );
      })
      .join("");
    list.querySelectorAll("[data-remove-id]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var rid = btn.getAttribute("data-remove-id");
        if (rid) window.SaveForLaterStore.removeById(rid);
      });
    });
    list.querySelectorAll("[data-restore-id]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var rid = btn.getAttribute("data-restore-id");
        if (rid) restoreToCart(rid);
      });
    });
  }

  function renderSavedListPage() {
    renderSavedListInto(document.getElementById("save-for-later-page-list"), {
      container: document.querySelector(".save-for-later-page-wrap"),
      empty: document.getElementById("save-for-later-page-empty"),
      toolbar: document.getElementById("save-for-later-page-toolbar"),
      showToolbar: true,
    });
  }

  function renderSavedListCart() {
    renderSavedListInto(document.getElementById("save-for-later-cart-list"), {
      container: document.querySelector(".save-for-later-cart-block"),
      empty: document.getElementById("save-for-later-cart-empty"),
      toolbar: null,
      showToolbar: false,
      hideWhenEmpty: true,
    });
  }

  function renderAllSavedListViews() {
    renderSavedListPage();
    renderSavedListCart();
  }

  function escapeHtml(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;");
  }

  class SaveForLaterButton extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener("click", this.onClick.bind(this));
    }

    onClick(e) {
      e.preventDefault();
      var cart = this.closest("cart-items");
      if (!cart || typeof cart.saveForLater !== "function") return;
      var line = this.dataset.cartLine;
      var snapshot = {
        id: this.dataset.variantId,
        lineKey: this.dataset.lineKey || "",
        name: this.dataset.productName || "",
        image: this.dataset.imageUrl || "",
        price: this.dataset.linePrice || "",
        productUrl: this.dataset.productUrl || "",
      };
      cart.saveForLater(parseInt(line, 10), snapshot);
    }
  }

  if (!customElements.get("save-for-later-button")) {
    customElements.define("save-for-later-button", SaveForLaterButton);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var clearBtn = document.getElementById("save-for-later-clear-all");
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        window.SaveForLaterStore.clearAll();
      });
    }
    renderAllSavedListViews();
  });
})();
